import React, { ReactElement } from 'react';
import FlexContainer from '../flex-container/flex-container.component';
import FormatService from '../../services/format-service';
import useStylesPaddedFlexContainer from './padded-flex-container.styles';

const PaddedFlexContainer: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    isSmall,
    isLarge,
    isExtended,
    isDefault,
    isStart,
    isEnd,
    isFlexStart,
    isColumn,
    isSpread,
    isInline,
    isCentered,
    isFloatLeft,
    isFloatRight,
    isFullWidth,
    isFullHeight,
    isTextLeft,
    isTextCenter,
    withNoAlign,
    withSpaceAround,
    className,
    minWidth,
    maxWidth,
    width,
    paddingTop,
    paddingLeft,
    paddingBottom,
    paddingRight,
    children,
  } = props;

  const { classes } = useStylesPaddedFlexContainer();

  const smallClassName: string | undefined = isSmall && !isDefault ? classes.paddedFlexContainerSmall : undefined;
  const largeClassName: string | undefined = isLarge && !isDefault ? classes.paddedFlexContainerLarge : undefined;
  const extendedClassName: string | undefined = isExtended && !isDefault
    ? classes.paddedFlexContainerExtended : undefined;

  return (
    <FlexContainer
      isStart={isStart}
      isEnd={isEnd}
      isFlexStart={isFlexStart}
      isColumn={isColumn}
      isSpread={isSpread}
      isInline={isInline}
      isCentered={isCentered}
      isFloatLeft={isFloatLeft}
      isFloatRight={isFloatRight}
      isFullWidth={isFullWidth}
      isFullHeight={isFullHeight}
      isTextLeft={isTextLeft}
      isTextCenter={isTextCenter}
      withNoAlign={withNoAlign}
      withSpaceAround={withSpaceAround}
      className={FormatService.formatClassNames(
        !isDefault ? classes.paddedFlexContainer : undefined,
        smallClassName, largeClassName, extendedClassName, className,
      )}
      style={{
        paddingTop: paddingTop || undefined,
        paddingLeft: paddingLeft || undefined,
        paddingBottom: paddingBottom || undefined,
        paddingRight: paddingRight || undefined,
        minWidth: minWidth || undefined,
        maxWidth: maxWidth || undefined,
        width: width || undefined,
      }}
    >
      {children}
    </FlexContainer>
  );
});

export default PaddedFlexContainer;
